import { get } from 'lodash/fp';
import workspaceSelector from 'selectors/workspaceSelector';

const locationSelector = (state, props = {}) =>
  get(['locations', props.locationId], workspaceSelector(state, props));

export default locationSelector;
